export const payment_method_routes = [
  {
    path: "/paymentmethods",
    component: () => import("../Main.vue"),
    name: "Métodos de Pagamento"
  }
];

export default {};
